import React from "react";
import { 
  Button, 
  Card, 
  Text,
} from "@fluentui/react-components";
import { useNavigate } from "react-router-dom";
import MetaData from "#root/layouts/MetaData";
import { ROUTES } from "#root/routes/constants";

const BadRequest: React.FC = () => {
  const navigate = useNavigate();

  return (
    <>
      <MetaData
        title="400 Bad Request"
        description="Sorry, something went wrong with your request."
      />
      <Card appearance="filled-alternative">
        <Text size={900} weight="bold" align="center">400</Text>
        <Text size={500} align="center">Sorry, something went wrong with your request.</Text>
        <Button appearance="primary" onClick={() => navigate(ROUTES.ROOT)} style={{ display: 'block', margin: '0 auto' }}>
          Back Home
        </Button>
      </Card>
    </>
  );
};

export default BadRequest;
